import { Alert } from 'antd';
import React from 'react';

import { useAsyncFeedback } from '../hooks/use-async-feedback';

interface AsyncFeedbackProps {
  inProcess: boolean;
  updatedAt?: number;
  error?: string;
  successMessage?: string;
  className?: string;
}

function AsyncFeedback({
  inProcess,
  updatedAt,
  error,
  successMessage = 'Saved successfully',
  className,
}: AsyncFeedbackProps): React.ReactElement | null {
  const showSuccess = useAsyncFeedback(updatedAt);

  if (error) {
    return <Alert className={className} type="error" title={error} showIcon />;
  }

  if (showSuccess && !inProcess) {
    return (
      <Alert
        className={className}
        type="success"
        title={successMessage}
        showIcon
      />
    );
  }

  return null;
}

export default AsyncFeedback;
